import { AccountClient } from '@frontend/account/api';
import { Account, AccountQueryParams } from '@frontend/account/types';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import React, { useState } from 'react';

const ID = 'account-select';
export const AccountSelectV2 = (props: ObjectSelectProps<Account, AccountQueryParams>) => {
    const [v, cV] = useState<Account | null>(null);
    return (
        <ObjectSelectInput<Account, AccountQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Account'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => AccountClient.fetchAccounts({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(account) => account.name}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'account',
                          fetch: (pathParam) => AccountClient.fetchAccount(pathParam)
                      }
                    : undefined
            }
            disabled={props.disabled}
            isClearable={props.isClearable}
        />
    );
};
